import clsx from "clsx"
import { FC } from "react"
import { numberFixed } from "@/helpers/numberFixed"
import { OutlinedText } from "@/ui/OutlinedText"
import styles from "./UpgradeCard.module.scss"
import { IUpgradeCard, upgradeIconMap } from "./index.ts"

export const UpgradeCard: FC<IUpgradeCard> = ({ data }) => {
  return (
    <div className={clsx(styles.UpgradeCard)}>
      <div className={clsx(styles.UpgradeCard_iconWrap)}>
        <div className={clsx(styles.UpgradeCard_icon)}>
          <img src={upgradeIconMap[data.type]} alt={data.type} />
        </div>
      </div>
      <div className={clsx(styles.UpgradeCard_label)}>
        Lvl.{" "}
        <OutlinedText className={clsx(styles.gold)}>
          {data.goldLevel}
        </OutlinedText>
        /
        <OutlinedText className={clsx(styles.bones)}>
          {data.bonesLevel}
        </OutlinedText>
      </div>
      <div className={clsx(styles.UpgradeCard_label)}>{numberFixed(84, 2)}</div>
    </div>
  )
}
